import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconFilter,
  IconSearch,
  IconTrash,
  IconLock,
  IconCopy,
  IconEdit,
  IconPlus,
  IconPencilUp,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Menu,
  ScrollArea,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  getDepartmentSelect,
  getOrganizationsSelect,
} from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import { ProcessDefsModel } from "../../model/ProcessDefsModel";
import { modals } from "@mantine/modals";
import { useNavigate } from "react-router-dom";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { pageTable, repositorySign, styleTable } from "../../_base/_const/_constVar";
import { TblSampleProcessModel } from "../../model/TblSampleProcessModel";
import {
  ListUserSearchModel,
  SampleProcessSearch,
} from "../../model/BaseSearchModel";
import { useForm } from "@mantine/form";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { stat } from "fs";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
const ProcessDefsTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<TblSampleProcessModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //

  const [dataorganizationId, setOrganizations] = useState<SelectListItem[]>([]);

  useEffect(() => {
    getOrganizations();
  }, []);

  async function getOrganizations() {
    const data = await getOrganizationsSelect();
    if (data && data.length > 0) setOrganizations(data);
  }

  useEffect(() => {
    // fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  const search: SampleProcessSearch = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setOpenedMenu(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    const queryParams: SampleProcessSearch = {
      skip: pagination.pageIndex * pagination.pageSize,
      take: pagination.pageSize,
      keySearch: form.getValues().keySearch,
      sort: _softing,
      isOrder: sorting.length > 0 ? sorting[0].desc : true,
      departmentId: form.getValues().departmentId,
      roleId: form.getValues().roleId,
    };

    const baseUrl = "/api/v1/SampleProcess/get-list";
    const queryString = Object.entries(queryParams)
      .reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          const stringValue =
            value instanceof Date ? value.toISOString() : value.toString();
          return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
        }
        return acc;
      }, "")
      .replace(/^&/, "");
    const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

    try {
      const response = await repositorySign.get<
        MessageResponse<TblSampleProcessModel[]>
      >(url);
      setData(response?.data ?? []);
      setRowCount(response?.totalCount ?? 0);
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const columns = React.useMemo<MRT_ColumnDef<TblSampleProcessModel>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "name",
        header: "Tên quy trình",
        size: 30,
      },
      {
        accessorKey: "doctypeName",
        header: "Loại tài liệu",
        size: 200,
      },

      {
        accessorKey: "active",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={renderedCellValue ? "green" : ""}>
              {renderedCellValue ? "Hoạt động" : "Không hoạt động"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "totalstep",
        header: "Số bước",
        size: 50,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <>
              <Tooltip label="Chỉnh sửa thông tin">
                <ActionIcon
                  onClick={async () => {
                    navigate(
                      "/process-defs/flow-model/edit/" + row.original.id
                    );
                  }}
                  variant="light"
                  aria-label="Settings"
                  color="cyan"
                >
                  <IconEdit size={14} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Sao chép">
                <ActionIcon variant="light" aria-label="Settings" color="grape">
                  <IconCopy size={14} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
              <Tooltip
                label={row.original.active ? "Khóa quy trình" : "Mở quy trình"}
              >
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="indigo"
                  onClick={async () => {
                    const url = "/api/v1/SampleProcess/actives";
                    const result = await repositorySign.post<
                      MessageResponse<boolean>
                    >(url, {
                      ids: [row.original.id],
                      status: !row.original.active,
                    });
                    if (result && result.httpStatusCode === 200) {
                      if (result.success) {
                        NotificationExtension.Success("Thành công !");
                        await fetchData();
                      } else
                        NotificationExtension.Fails(
                          result.message.length > 0
                            ? result.message
                            : "Thất bại !"
                        );
                      //   setDisabledBtn(false);
                    }
                  }}
                >
                  <IconLock size={14} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Xóa">
                <ActionIcon
                  onClick={async () => {
                    modals.openConfirmModal({
                      title: "Xóa",
                      children: <>Bạn có thực sự muốn thao tác xóa !</>,
                      labels: { confirm: "Xác nhận", cancel: "Hủy bỏ" },
                      onCancel: () => console.log("Cancel"),
                      onConfirm: async () => {
                        const url = "/api/v1/SampleProcess/delete";
                        const result = await repositorySign.post<
                          MessageResponse<boolean>
                        >(url, [row.original.id]);
                        if (result && result.httpStatusCode === 200) {
                          if (result.success) {
                            await fetchData();
                            NotificationExtension.Success("Thành công !");
                          } else
                            NotificationExtension.Fails(
                              result.message.length > 0
                                ? result.message
                                : "Thất bại !"
                            );
                          //   setDisabledBtn(false);
                        }
                      },
                    });
                  }}
                  variant="light"
                  aria-label="Settings"
                  color="red"
                >
                  <IconTrash size={14} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </>
          </Box>
        ),
      },
    ],
    []
  );
  const navigate = useNavigate();

  const openHistoryFlow = () => {
    navigate("/process-defs/flow-model/create");
  };

  const [openedMenu, setOpenedMenu] = useState(true);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection });
  }, [rowSelection]);
  const _span = { base: 4, md: 3, lg: 2 };
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);

  useEffect(() => {
    getDepartmentSelect().then((x) => {
      setDataFetch(x);
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,

    localization: _localization,
    enableRowSelection: false,
    enableTopToolbar: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        //  left: ["mrt-row-select", "attachmentsCode"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  //#endregion
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Button
            leftSection={<IconPlus size={14} />}
            color="violet"
            variant="outline"
            onClick={openHistoryFlow}
          >
            Thêm mới
          </Button>
        </Flex>
        <form>
          <Grid>
            <Grid.Col span={_span}>
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Đơn vị"
                leftSection={<IconPencilUp color="#15aabf" />}
                placeholder="Chọn đơn vị trình ký"
                data={dataFetch.map((employee) => ({
                  value: employee.value,
                  label: employee.text,
                }))}
                limit={20}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                key={form.key(`departmentId`)}
                {...form.getInputProps("departmentId")}
                nothingFoundMessage="Không có dữ liệu"
                searchable
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ProcessDefsTable;
